/*
 * ml-klaviyo-eventos.js · el «Added to Cart» que solo puede mandar el tema
 * ══════════════════════════════════════════════════════════════════════
 *
 * QUE RESUELVE, Y QUE NO HACE FALTA QUE RESUELVA. El cliente quiere un flujo
 * de carrito abandonado y otro de producto visto. De los tres eventos que eso
 * pide, dos ya existen y uno no, y conviene tener claro cual es cual antes de
 * leer una linea de aqui:
 *
 *   Checkout started · lo manda el servidor de Shopify por la integracion.
 *   Viewed Product   · LO MANDA YA LA APP DE KLAVIYO, no el tema. Va dentro
 *                      de content_for_header, en un <script id="viewed_product">
 *                      que empuja a _learnq un «track Viewed Product» y un
 *                      «trackViewedItem». Medido el 10/09/2026 sobre
 *                      shopify theme dev, en la ficha del curso: la cola traia
 *                      las dos entradas con su carga entera —Name, ProductID,
 *                      Categories con las cuatro colecciones, ImageURL, URL,
 *                      Brand, Price, Value y CompareAtPrice—. Escribir aqui
 *                      otro Viewed Product habria DUPLICADO la metrica.
 *   Added to Cart    · no lo manda nadie. Medido el mismo dia: la cadena
 *                      «Added to Cart» no aparece ni una vez en el HTML de la
 *                      ficha, ni de la portada, ni de la tienda, ni de /cart.
 *                      Eso es lo unico que escribe este archivo.
 *
 * Y POR QUE EL TEMA Y NO LA APP. Porque anadir al carrito en esta tienda no
 * recarga la pagina: Horizon intercepta el envio, llama a /cart/add.js y
 * sustituye HTML. El servidor no se entera, asi que el unico sitio desde el
 * que se puede contar es el navegador.
 *
 * ══════════════════════════════════════════════════════════════════════
 * AL EVENTO SE LE PREGUNTA EN LA RAIZ, NO EN «detail»
 * ══════════════════════════════════════════════════════════════════════
 * «shopify:cart:lines-update» es un evento estandar de Shopify, no un
 * CustomEvent: la clase base hace Object.assign(this, payload), asi que
 * «action», «context», «lines» y «promise» acaban en el evento y «detail» es
 * un campo opcional que normalmente NO EXISTE. Medido el 10/09/2026 en la
 * ficha del curso, con un clic de raton de verdad:
 *
 *   action=add  context=product  detail.action=undefined  promesa=true
 *   lines=[{"quantity":1,"merchandiseId":"gid://shopify/ProductVariant/56013019119993"}]
 *
 * Filtrar con «e.detail.action !== "add"» es no filtrar nada: compara
 * undefined con "add", da siempre distinto, y el codigo se cuela entero
 * tambien al QUITAR una linea. Costo las dos barras de compra del tema desde
 * el 21/08 hasta el 03/09/2026, cuatro familias diciendo «Anadido» cuando el
 * cliente quitaba. Lo vigila la prueba N29 del banco de navegador. El
 * contrato entero esta en assets/standard-events.d.ts.
 *
 * Ojo con el matiz que se aprendio el mismo dia: «klaviyoForms» SI es un
 * CustomEvent de verdad y ahi «detail» es lo correcto. Es lo que hace
 * ml-klaviyo-huella.js, y no se contradicen: son dos contratos distintos.
 *
 * ══════════════════════════════════════════════════════════════════════
 * SE ESPERA A LA PROMESA, Y ESO NO ES PRUDENCIA
 * ══════════════════════════════════════════════════════════════════════
 * El evento se dispara ANTES de que el carrito haya cambiado —primero el
 * dispatchEvent y despues el fetch, se ve en assets/component-cart-items.js—,
 * asi que preguntar por /cart.js a secas devuelve la cesta de antes y el
 * correo de carrito abandonado saldria con una linea de menos. Es la misma
 * leccion que ya aprendio ml-anuncio.js el 04/09/2026 con la barra de envio.
 *
 * Y si la promesa se rompe, aqui NO se manda el evento, al reves que en
 * ml-anuncio.js: alli un fallo dejaba la cesta como estaba y refrescar era lo
 * correcto; aqui un fallo significa que el producto no ha entrado en la
 * cesta, y contar un anadido que no ocurrio es peor que no contar nada.
 *
 * NI UNA PROMESA SIN DUENO. Todo lleva su rama de rechazo, incluida la que
 * devuelve klaviyo.track(). Es la leccion del 26/08/2026: un rechazo sin
 * dueno no rompe la ejecucion, no sale por «pageerror», no deja rastro en el
 * HTML, y el navegador —y Clarity— lo cuentan como error igual. Lo vigila N19.
 *
 * ══════════════════════════════════════════════════════════════════════
 * EL CONSENTIMIENTO SE PREGUNTA AQUI, Y NO SE DA POR HECHO
 * ══════════════════════════════════════════════════════════════════════
 * La tienda tiene el banner de cookies de Shopify puesto y el cliente puede
 * rechazar. Medido el 10/09/2026 al cargar la ficha, antes de tocar nada:
 *
 *   analyticsProcessingAllowed() false · marketingAllowed() false
 *   currentVisitorConsent()  {marketing:"", analytics:"", preferences:"", sale_of_data:""}
 *   cookies: localization, cart_currency   (ni rastro de __kla_id)
 *   peticiones POST a klaviyo: NINGUNA en 25 cargas de guion
 *
 * O sea que Klaviyo, que lee la Customer Privacy API de Shopify, ya se calla
 * sola. Aun asi se pregunta aqui tambien, por dos motivos: porque una regla
 * de privacidad que depende de que un tercero se porte bien no es una regla,
 * y porque asi el rechazo se puede MEDIR en el banco —el gate de Klaviyo no,
 * ver el apartado de abajo—. Si algun dia Klaviyo dejara de mirarlo, esto
 * sigue siendo correcto.
 *
 * Se exigen las DOS: analitica y marketing. La analitica es lo que permite
 * medir, y el marketing es para lo que sirve este evento —escribirle a
 * alguien—: quien acepta medir pero no que le escriban no deberia disparar un
 * flujo de correo. Y si la API no existe, se manda: fuera de la UE no hay
 * regimen de consentimiento que respetar y bloquear ahi seria apagar la
 * medicion de toda la tienda por un banner que no se pinta.
 *
 * ══════════════════════════════════════════════════════════════════════
 * «PARA CLIENTES IDENTIFICADOS»: POR QUE SE MANDA IGUAL, Y MARCADO
 * ══════════════════════════════════════════════════════════════════════
 * El cliente lo pidio con esas palabras. Se ha resuelto mandando SIEMPRE y
 * etiquetando, en vez de callar cuando no hay identidad, y la decision se
 * tomo despues de medir, no antes:
 *
 * 1 · NO SE PUEDE PREGUNTAR SIN COLGARSE. klaviyo.isIdentified() devuelve una
 *     promesa, y el 10/09/2026 se midio en tres estados seguidos sobre la
 *     misma pestana: sin consentimiento, con consentimiento, y despues de
 *     llamar a klaviyo.identify(). Los tres, PENDIENTE tras cinco y seis
 *     segundos. Tambien se quedo pendiente klaviyo.cookieDomain(), y
 *     window._klOnsite estaba vacio: en 127.0.0.1 klaviyo.js no termina de
 *     arrancar nunca. Una puerta apoyada en esa promesa no habria dejado
 *     pasar ni un evento, y sin dar ningun error.
 * 2 · KLAVIYO YA FILTRA DONDE IMPORTA. Un flujo solo puede escribirle a un
 *     perfil con correo y con consentimiento. O sea que la condicion del
 *     cliente se cumple en Klaviyo tanto si el evento anonimo llega como si
 *     no; lo unico que cambia es la metrica.
 * 3 · Y CALLAR COSTARIA JUSTO EL CASO QUE MAS VALE. Klaviyo guarda el evento
 *     anonimo contra la cookie __kla_id y lo engancha al perfil en cuanto esa
 *     persona se identifica. Quien anade al carrito y treinta segundos
 *     despues deja su correo en el emergente es exactamente a quien hay que
 *     escribirle, y con la puerta cerrada ese carrito no habria existido.
 *
 * Asi que va la propiedad «ClienteIdentificado», con «si» o «no» en texto
 * —la regla 3 del convenio de klaviyo/PROPIEDADES.md: nunca true, que desde
 * un boton de correo no se puede escribir— y el cliente decide en Klaviyo:
 * con el filtro puesto en el disparador tiene su lectura literal, sin el
 * filtro se queda tambien con los que se identifican despues.
 *
 * De donde sale el «si»: de la cookie __kla_id, que es base64 de un JSON.
 * Mientras la visita es anonima solo trae «cid»; al identificarse aparece
 * «$exchange_id». Es la misma cookie que lee Klaviyo por dentro con
 * _getClientIdFromCookie. Si algun dia cambia de forma, el decodificador
 * falla, la etiqueta dice «no» y el evento SE MANDA IGUAL: se degrada la
 * etiqueta, nunca el evento.
 *
 * ══════════════════════════════════════════════════════════════════════
 * LO QUE ESTE ARCHIVO NO PUEDE DEMOSTRAR EN LOCAL
 * ══════════════════════════════════════════════════════════════════════
 * Que Klaviyo RECIBE el evento. En 127.0.0.1 klaviyo.js carga sus veinticinco
 * guiones y ahi se queda: no escribe __kla_id —su dominio de cookie es el de
 * la tienda—, no resuelve ninguna de sus promesas y no manda ni un POST, ni
 * siquiera despues de aceptar el consentimiento y llamar a identify(). Es la
 * misma clase de limite que ya esta escrita en CLAUDE.md para los filtros de
 * Shopify: hay medidas que solo valen en el dominio real.
 *
 * Lo que si se mide en el banco, y es lo que este archivo controla, es que la
 * llamada SALE con la carga correcta y una sola vez. Que llegue se comprueba
 * en el dominio de la tienda, mirando la metrica en Klaviyo.
 */
(function () {
  'use strict';

  /* Una sola instalacion por pagina. El guion se carga desde el layout, o sea
     una vez, pero el editor de temas recarga secciones y un dia alguien puede
     enlazarlo tambien desde una seccion: dos escuchas serian dos eventos por
     anadido, que es justo lo que no puede pasar. */
  if (window.mlKlaviyoEventos) { return; }
  window.mlKlaviyoEventos = true;

  var EVENTO = 'Added to Cart';

  /* El mismo objeto Event no se cuenta dos veces. Es una red distinta de la de
     arriba y tapa otro agujero: alli, dos escuchas; aqui, una escucha a la que
     le llega dos veces el mismo evento —por ejemplo si alguien lo reemite en
     la fase de captura y en la de burbuja—. Dos anadidos de verdad son dos
     objetos distintos, asi que esta red no puede esconder una compra. */
  var atendidos = (typeof window.WeakSet === 'function') ? new window.WeakSet() : null;

  /* ── Consentimiento ─────────────────────────────────────────────── */
  function sePuedeMedir() {
    var api = window.Shopify ? window.Shopify.customerPrivacy : null;
    if (!api) { return true; }
    try {
      if (typeof api.analyticsProcessingAllowed !== 'function') { return true; }
      if (!api.analyticsProcessingAllowed()) { return false; }
      if (typeof api.marketingAllowed !== 'function') { return true; }
      if (!api.marketingAllowed()) { return false; }
      return true;
    } catch (e) {
      /* Si la API esta y protesta, no se sabe que ha consentido esta persona.
         Sin saberlo, no se manda: es lo unico que no se puede deshacer. */
      return false;
    }
  }

  /* ── ¿Sabe ya Klaviyo quien es? ─────────────────────────────────── */
  function hayIdentidad() {
    var trozos = String(document.cookie || '').split(';');
    for (var i = 0; i < trozos.length; i++) {
      var t = trozos[i];
      while (t.charAt(0) === ' ') { t = t.slice(1); }
      if (t.indexOf('__kla_id=') !== 0) { continue; }
      try {
        var json = JSON.parse(window.atob(decodeURIComponent(t.slice(9))));
        if (json.$exchange_id) { return true; }
        if (json.$email) { return true; }
        if (json.$phone_number) { return true; }
        if (json.$external_id) { return true; }
        return false;
      } catch (e) {
        return false;
      }
    }
    return false;
  }

  /* ── Utilidades de la carga ─────────────────────────────────────── */

  /* Los precios de /cart.js vienen en centimos y Klaviyo espera un numero con
     el que poder hacer cuentas —«valor del carrito mayor que»— y con el que
     pintar el importe en la plantilla. Se manda numero y aparte la moneda: la
     cadena con simbolo la sabe formatear Klaviyo y no la sabe sumar. */
  function euros(centimos) {
    var n = Number(centimos);
    if (!isFinite(n)) { return 0; }
    return Math.round(n) / 100;
  }

  /* «gid://shopify/ProductVariant/56013019119993» → «56013019119993». Es lo
     que trae e.lines[i].merchandiseId y lo unico que permite emparejar la
     linea recien anadida con su linea de /cart.js, que usa el id pelado. */
  function idDeGid(gid) {
    var texto = String(gid == null ? '' : gid);
    var corte = texto.lastIndexOf('/');
    if (corte === -1) { return texto; }
    return texto.slice(corte + 1);
  }

  function absoluta(url) {
    var texto = String(url == null ? '' : url);
    if (!texto) { return ''; }
    if (texto.indexOf('//') === 0) { return window.location.protocol + texto; }
    if (texto.indexOf('http') === 0) { return texto; }
    return window.location.origin + texto;
  }

  /* La categoria sale de product_type y no de las colecciones, y esto es una
     renuncia consciente: /cart.js no trae colecciones, y pedirlas seria una
     peticion mas por producto del carrito. El Viewed Product de la app SI
     manda las colecciones, asi que los dos eventos no dicen lo mismo en esta
     propiedad. Queda escrito para que dentro de un ano nadie lo lea como un
     descuido. */
  function categorias(linea) {
    if (!linea) { return []; }
    if (!linea.product_type) { return []; }
    return [linea.product_type];
  }

  function itemDeLinea(linea) {
    return {
      ProductID: linea.product_id,
      VariantID: linea.variant_id,
      SKU: linea.sku || '',
      ProductName: linea.product_title || linea.title || '',
      Quantity: linea.quantity,
      ItemPrice: euros(linea.final_price),
      RowTotal: euros(linea.final_line_price),
      ProductURL: absoluta(linea.url),
      ImageURL: absoluta(linea.image),
      ProductCategories: categorias(linea),
    };
  }

  /* ── La carga entera ────────────────────────────────────────────── */

  /* Los nombres son los que Klaviyo espera para este evento y no se pueden
     traducir: son los que leen sus plantillas de carrito abandonado, o sea lo
     que decide si el correo sale con la foto y el nombre del producto o sale
     pobre. El unico nombre nuestro es ClienteIdentificado.
     https://developers.klaviyo.com/en/docs/guide_to_integrating_a_platform_without_a_pre_built_klaviyo_integration
   */
  function cargaDeAnadido(carrito, lineaAnadida, cuantasSeAnadieron) {
    var items = [];
    var nombres = [];
    var lineas = carrito.items || [];
    for (var i = 0; i < lineas.length; i++) {
      items.push(itemDeLinea(lineas[i]));
      nombres.push(lineas[i].product_title || lineas[i].title || '');
    }

    var raiz = '/';
    if (window.Shopify) {
      if (window.Shopify.routes) {
        if (window.Shopify.routes.root) { raiz = window.Shopify.routes.root; }
      }
    }
    if (raiz.charAt(raiz.length - 1) !== '/') { raiz += '/'; }

    var moneda = carrito.currency || '';
    if (!moneda) {
      if (window.Shopify) {
        if (window.Shopify.currency) { moneda = window.Shopify.currency.active || ''; }
      }
    }

    var datos = {
      $value: euros(carrito.total_price),
      Currency: moneda,
      ItemNames: nombres,
      Items: items,
      CheckoutURL: window.location.origin + raiz + 'checkout',
      CartToken: carrito.token || '',
      CartItemCount: carrito.item_count,
      ClienteIdentificado: hayIdentidad() ? 'si' : 'no',
    };

    /* EL ENLACE QUE DEVUELVE LA CESTA, Y VA APARTE DE «CheckoutURL» A
       PROPOSITO. «CheckoutURL» lleva a /checkout, que es lo que Klaviyo espera
       en este evento, pero /checkout en OTRO dispositivo —que es donde se lee
       un correo— sale vacio: la cesta vive en una cookie del navegador que la
       lleno. El enlace permanente de cesta de Shopify, /cart/c/<token>, si la
       devuelve, y el token que da /cart.js ya trae su clave pegada
       —«hWNGfHcHZPUOaRayNwESGsNS?key=17e18b94…»—, asi que no hay que componer
       nada.

       SE MANDA COMO SUPOSICION Y ASI ESTA ESCRITO: por 127.0.0.1 ese enlace
       contesta 302 y la redireccion acaba en 401, que es la puerta del proxy de
       theme dev y no el tema. O sea que la forma esta comprobada y el
       funcionamiento no. Antes de colgarlo del boton de un correo hay que
       abrirlo una vez en el dominio de la tienda. Mientras tanto viaja como un
       dato mas: no rompe nada y no lo usa nadie sin querer. */
    if (carrito.token) {
      datos.CartRecoveryURL = window.location.origin + raiz + 'cart/c/' + carrito.token;
    }

    if (lineaAnadida) {
      datos.AddedItemProductName = lineaAnadida.product_title || lineaAnadida.title || '';
      datos.AddedItemProductID = lineaAnadida.product_id;
      datos.AddedItemVariantID = lineaAnadida.variant_id;
      datos.AddedItemSKU = lineaAnadida.sku || '';
      datos.AddedItemCategories = categorias(lineaAnadida);
      datos.AddedItemImageURL = absoluta(lineaAnadida.image);
      datos.AddedItemURL = absoluta(lineaAnadida.url);
      datos.AddedItemPrice = euros(lineaAnadida.final_price);
      /* La cantidad ES LA QUE SE ACABA DE ANADIR, no la de la linea. Quien ya
         tenia una unidad y anade otra deja la linea en dos, y decir dos aqui
         seria contar la vieja otra vez. Sale del evento, que es el unico que
         sabe cuanto se ha pedido. */
      datos.AddedItemQuantity = cuantasSeAnadieron;
    }

    return datos;
  }

  /* ── Empujar a Klaviyo ──────────────────────────────────────────── */

  /* DOS CAMINOS Y NINGUNA ESPERA. El objeto window.klaviyo es la API moderna y
     es lo que ya prefiere ml-klaviyo-huella.js, asi que se prueba primero. Si
     no esta, se empuja al array _learnq, que es el mecanismo documentado para
     llamar antes de que el guion haya cargado y es exactamente lo que hace el
     propio <script id="viewed_product"> de la app de Klaviyo.
     Por eso aqui no hay el bucle de veinte intentos que si tiene la huella:
     alli hacia falta porque identify() no tiene equivalente en cola que se
     pueda crear desde cero; aqui _learnq se puede crear y Klaviyo lo vacia al
     arrancar. Una espera de cinco segundos que no hace falta es una espera en
     la que la clienta puede haber cerrado la pestana. */
  function empujar(nombre, datos) {
    var k = window.klaviyo;
    if (k) {
      if (typeof k.track === 'function') {
        var devuelto = k.track(nombre, datos);
        if (devuelto) {
          if (typeof devuelto.catch === 'function') {
            /* Sin dueno no se queda ninguna. N19. */
            devuelto.catch(function () {});
          }
        }
        return 'klaviyo.track';
      }
    }
    window._learnq = window._learnq || [];
    window._learnq.push(['track', nombre, datos]);
    return '_learnq';
  }

  /* ── La escucha ─────────────────────────────────────────────────── */
  document.addEventListener('shopify:cart:lines-update', function (e) {
    if (!e) { return; }
    /* EN LA RAIZ. Ver la cabecera: con «e.detail.action» esto se dispararia
       tambien al quitar y al cambiar cantidad. Medido el 10/09/2026: pulsar
       el «+» del cajon manda action «update», y quitar manda «remove». */
    if (e.action !== 'add') { return; }
    if (atendidos) {
      if (atendidos.has(e)) { return; }
      atendidos.add(e);
    }
    /* Se pregunta ANTES de pedir /cart.js: quien ha rechazado las cookies no
       tiene por que pagar una peticion de red que no va a servir para nada. */
    if (!sePuedeMedir()) { return; }

    var lineas = e.lines || [];
    var primera = lineas[0] || null;
    /* Si un dia un anadido trae varias lineas —un pack—, las propiedades
       AddedItem* describen la primera y «Items» describe el carrito entero.
       Es la forma que Klaviyo define para este evento: tiene un solo hueco de
       articulo anadido. Hoy no pasa: medido, un anadido es una linea. */
    var variante = primera ? idDeGid(primera.merchandiseId) : '';
    var cuantas = primera ? primera.quantity : 0;

    function seguir() {
      var raiz = '/';
      if (window.Shopify) {
        if (window.Shopify.routes) {
          if (window.Shopify.routes.root) { raiz = window.Shopify.routes.root; }
        }
      }
      if (raiz.charAt(raiz.length - 1) !== '/') { raiz += '/'; }

      window.fetch(raiz + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          if (!r.ok) { return null; }
          return r.json();
        })
        .then(function (carrito) {
          if (!carrito) { return; }
          if (!carrito.items) { return; }
          var anadida = null;
          for (var i = 0; i < carrito.items.length; i++) {
            if (String(carrito.items[i].variant_id) === variante) {
              anadida = carrito.items[i];
              break;
            }
          }
          empujar(EVENTO, cargaDeAnadido(carrito, anadida, cuantas));
        })
        .catch(function () {
          /* Sin dueno no se queda ninguna, y sin console: esto corre en todas
             las paginas y un aviso por cada anadido llena la consola de quien
             esta depurando otra cosa. Un evento perdido es un correo que no
             sale; un error en consola es ruido en todas las sesiones. */
        });
    }

    /* POR QUE SE ESPERA. El evento va por delante del carrito: preguntar ahora
       devuelve la cesta de antes. Y si la promesa se rompe, el producto no ha
       entrado: no hay nada que contar. */
    if (e.promise) {
      if (typeof e.promise.then === 'function') {
        e.promise.then(function (resultado) {
          if (!resultado) { return; }
          /* cart en null es el anadido que no llego a ocurrir. */
          if (!resultado.cart) { return; }
          seguir();
        }, function () {
          /* Rechazo atendido a proposito y sin hacer nada mas. N19. */
        });
        return;
      }
    }
    seguir();
  });
})();
